import { getSession } from "../utilities/Crypto";
import { dataUserSession } from "../utilities/dataSession";

const SERVER_NAME = window.location.hostname;

// export const APP_VERSION = '1.2';
// export const APP_DEPLOY = '25/07/2565 09.30 น.';

//--Jane 
export const APP_VERSION = '1.3';
export const APP_DEPLOY = '19/10/2567 09.00 น.';


export const config_headers = async () => {
    try {
      
            return {
            
                headers: {
                    pmsToken: dataUserSession() ? dataUserSession().token : "undefined",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET,PUT,POST",
                },
            };

        
       
    } catch (error) {
        return undefined;
        // return { headers: { Authorization: "Bearer " + await getSession("QA-LOGIN").accessToken } };
    }
};

export const config_headers_export = async (exportType = "") => {
    try {
      
            return {
                responseType: "arraybuffer",
                headers: {
                    pmsToken: dataUserSession() ? dataUserSession().token : "undefined",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET,PUT,POST",
                    "Content-Type": "application/json",
                    Accept: "application/" + exportType,
                },
            };

        
       
    } catch (error) {
        return undefined;
        // return { headers: { Authorization: "Bearer " + await getSession("QA-LOGIN").accessToken } };
    }
};



export const config_headers_fromData = async (fromData) => {
    try {
        return { headers: { Authorization: "Bearer " + (await getSession("login").access_token), "Content-Type": "multipart/form-data" } };
    } catch (error) {
        return undefined;
    }
};

export const config_headers_delete = async (params) => {
    try {
        return { data: params, headers: { Authorization: "Bearer " + (await getSession("login").access_token) } };
    } catch (error) {
        return undefined;
    }
};

export const URL_MAP_DEFAULT = () => {
    let URL = "";

    if ("localhost" === SERVER_NAME || "sitdev.dyndns.org" === SERVER_NAME) {
        URL = "http://sitdev.dyndns.org:9107";
    } else if (window.location.hostname.indexOf("172.19.9.127") !== -1) {
        URL = "https://pms.mwa.co.th/Gis";
    } else if (window.location.hostname.indexOf("pms") !== -1) {
        URL = "https://pms.mwa.co.th/Gis";
    }

    return URL;
}

export const URL_API = (API) => {
    let URL = "";

    //MWA SERVICE
    // URL = "http://172.19.9.127:12010/PMSService";
    // URL = "http://172.20.128.64:12010/PMSService";
    // URL = "https://pms.mwa.co.th/PMSService";

    // SENSE SERVICE
    // URL = "http://senseinfotech.dyndns.org:9104/PMSService";
    // URL = "http://sitdev.dyndns.org:9104/PMSService";

    if ("localhost" === SERVER_NAME || "sitdev.dyndns.org" === SERVER_NAME) {
        URL = "http://sitdev.dyndns.org:9104/PMSService";
        //URL = "http://localhost:8080/PMSService";
    } else if (window.location.hostname.indexOf("172.19.9.127") !== -1) {
        URL = "http://172.19.9.127:12010/PMSService";
    } else if (window.location.hostname.indexOf("pms") !== -1) {
        URL = "https://pms.mwa.co.th/PMSService";
    }

    // URL = URL_DEFAULT + "/PMSService"
    return URL + API;
};

export const URL_PIC = (pathPic) => {
    let URL = "";
    let UrlPic = "";
    let subfix = "/usr/local/tomcat/webapps/pic/";
    if (pathPic !== "") {
        UrlPic = pathPic.replace(subfix, "");
    }

    //MWA SERVICE
    // URL = "http://172.19.9.127:12010/pic/";
    // URL = "http://172.20.128.64:12010/pic/";
    // URL = "https://pms.mwa.co.th/pic/";

    // SENSE SERVICE
    // URL = "http://senseinfotech.dyndns.org:9104/pic/";
    // URL = "http://sitdev.dyndns.org:9104/pic/";

    if ("localhost" === SERVER_NAME || "sitdev.dyndns.org" === SERVER_NAME) {
        URL = "http://sitdev.dyndns.org:9104/pic/";
    } else if (window.location.hostname.indexOf("172.19.9.127") !== -1) {
        URL = "http://172.19.9.127:12010/pic/";
    } else if (window.location.hostname.indexOf("pms") !== -1) {
        URL = "https://pms.mwa.co.th/pic/";
    }

    // URL = URL_DEFAULT + "/pic/"
    return URL + UrlPic;
};

export const servicelist = {
    AppService: "/rest/internal/app/",
    AuthService: "/rest/internal/auth/",
    assessmentService: "/rest/internal/assessment/",
    BoqService: "/rest/internal/boq/",
    ExecutiveService: "/rest/internal/executive/",
    GenService: "/rest/internal/gen/",
    committeeService: "/rest/internal/committee/",
    contractorService: "/rest/internal/contractor/",
    CtService: "/rest/internal/ct/",
    PerformanceService: "/rest/internal/performance/",
    SupervisorService: "/rest/internal/supervisor/",
    TokenService: "/public/token/",
    UserService: "/rest/internal/user/",
    P1Service: "/rest/internal/p1/",
    P2Service: "/rest/internal/p2/",
    RequestService: "/rest/internal/request/",
    CIAService: "/rest/internal/cia/",

};
